import { Loader } from "@app/components/core/Loader/Loader"
import MyParadiseOrderHistoryModal from "@app/modals/MyParadise/MyParadiseOrderHistoryModal/MyParadiseOrderHistoryModal"
import { useGetOrder, useGetOrderHistory } from "@app/store/service/connectorService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { getDateString, getPriceString } from "@app/utils/localeUtils"
import { useModal, useViewport } from "@tecreation/funnel-components"
import { useEffect, useState } from "react"
import "./MyParadiseOrderHistory.css"
export const MyParadiseOrderHistory = () => {
	const { showModal } = useModal()
	const { data: orderHistory } = useGetOrderHistory()
	const [webToken, setWebToken] = useState(undefined)

	const { data: order, isUninitialized, isFetching } = useGetOrder({ webToken: webToken }, { skip: !webToken })
	const [previewOrder, setPreviewOrder] = useState()
	const { sm } = useViewport()

	useEffect(() => {
		if (orderHistory && orderHistory.length > 0) {
			let webToken = orderHistory.find(e => e.webToken).webToken
			setWebToken(webToken)
		}
	}, [orderHistory])

	useEffect(() => {
		if (order) {
			let orderLines = [...order.orderLines]

			/**
			 * Filter the Orderlines, so the order history only shows actual orders with positive quantity and no payments.
			 */

			orderLines = orderLines.filter(line => {
				if (line.typeId === ORDER_LINE_TYPES.Payment) return false

				if (line.typeId === ORDER_LINE_TYPES.VoucherDetail) return false

				if (line.typeId === ORDER_LINE_TYPES.Account && !line.eft) return true

				if (line.quantity > 0) return true

				return false
			})

			/**
			 * Grouping Orders after Type, so if a guest books 3 tickets for VitalTherme the tickets will show as "3x vitaltherme" in the order history
			 * and not as a list of 3 single tickets .
			 */
			for (let i = 0; i < orderLines.length; i++) {
				let line = orderLines[i]
				let count = orderLines.length - 1
				while (count > i) {
					let compareLine = orderLines[count]
					if (line.typeId === compareLine.typeId) {
						let didMatch = false
						if (line.typeId === ORDER_LINE_TYPES.Object || line.typeId === ORDER_LINE_TYPES.ObjectGroup) {
							if (line.details[0].description === compareLine.details[0].description) {
								didMatch = true
							}
						} else if (line.id === compareLine.id) {
							didMatch = true
						}
						if (didMatch) {
							line = orderLines[i] = {
								...line,
								quantity: line.quantity + compareLine.quantity,
							}
							orderLines.splice(count, 1)
						}
					}
					count--
				}
			}

			let tickets = []
			let loungers = []
			let other = []
			orderLines.forEach(line => {
				if (line.typeId === ORDER_LINE_TYPES.Ticket) {
					tickets.push(line)
				} else if (line.typeId === ORDER_LINE_TYPES.Object || line.typeId === ORDER_LINE_TYPES.ObjectGroup) {
					loungers.push(line)
				} else {
					if (line.typeId === ORDER_LINE_TYPES.Account && line.eft) {
						//ignore Account Lines with an eft because that is a paymentLine and we dont want to show that
					} else {
						other.push(line)
					}
				}
			})
			tickets.sort((a, b) => {
				return a.id - b.id
			})
			loungers.sort((a, b) => {
				return a.id - b.id
			})
			other.sort((a, b) => {
				return a.id - b.id
			})
			let final = [...tickets, ...loungers, ...other]
			setPreviewOrder(final)
		}
	}, [order])

	return (
		<div
			className={`myParadiseOrderHistory h-100 color-bg-secondary-100 flex flex-column p-4 ${sm ? "flex-items-baseline" : "flex-items-center"}`}
			onClick={() => {
				orderHistory ? showModal(MyParadiseOrderHistoryModal) : null
			}}
		>
			<Loader show={isUninitialized || isFetching} />

			{!isUninitialized && !isFetching && order && previewOrder && (
				<>
					<h3 className="color-fg-secondary regular flex-self-baseline mb-2">{getDateString(new Date(order.orderDate))}</h3>
					{previewOrder.map((e, i) => {
						if (i <= 200) {
							return (
								<div key={i} className="mt-1 border-bottom pb-2 line-clamp-6">
									{e.quantity}x {e.details[0].translation ? e.details[0].translation : e.details[0].description}
								</div>
							)
						}
					})}
					<div className="color-fg-default regular">{getPriceString(order.payAmount)}</div>
				</>
			)}
		</div>
	)
}
